module.exports = __webpack_public_path__ + "img/2024big18.31b42883.png";